

















import Modal from '@/components/mixins/Modal';

export default Modal.extend({
    props: {
        title: {
            type: String,
            default: null,
        },
        message: {
            type: String,
            required: true,
        },
    },
});
